import { render, staticRenderFns } from "./LoaderSkeletonChartRadial.vue?vue&type=template&id=5a31d479&scoped=true&"
import script from "./LoaderSkeletonChartRadial.vue?vue&type=script&lang=js&"
export * from "./LoaderSkeletonChartRadial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a31d479",
  null
  
)

export default component.exports